// extracted by mini-css-extract-plugin
module.exports = {"prefix":"prefix___2WnWe","select":"select___3VuKS","input":"input___2ybsR"};